export const API_LIST_MEDIA_FILES = "/api/v3/media-libs";
export const API_CREATE_MEDIA_FILE = "/api/v3/media-lib";
export const API_DELETE_MEDIA_FILE = "/api/v3/media-lib/%reference%";
export const API_UPDATE_MEDIA_FILE = "/api/v3/media-lib/%reference%";
